var _path, _path2, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgConnectEmailIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 4.8H4.266C3.24 4.8 2.4 5.64 2.4 6.667v11.2c0 1.026.84 1.866 1.866 1.866H19.2c1.027 0 1.867-.84 1.867-1.867v-11.2c0-1.026-.84-1.866-1.867-1.866zm0 13.066h-1.867V9.653l-5.6 3.547-5.6-3.547v8.213H4.266v-11.2h1.12l6.347 3.92 6.346-3.92h1.12v11.2z",
    fill: "url(#connect-email-icon_svg__paint0_linear_7070_120615)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2 4.8H4.266C3.24 4.8 2.4 5.64 2.4 6.667v11.2c0 1.026.84 1.866 1.866 1.866H19.2c1.027 0 1.867-.84 1.867-1.867v-11.2c0-1.026-.84-1.866-1.867-1.866zm0 13.066h-1.867V9.653l-5.6 3.547-5.6-3.547v8.213H4.266v-11.2h1.12l6.347 3.92 6.346-3.92h1.12v11.2z",
    fill: "#A5BBD4"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "connect-email-icon_svg__paint0_linear_7070_120615",
    x1: 21.438,
    y1: 4.937,
    x2: 6.716,
    y2: 23.343,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0.6
  })))));
}

export default __webpack_public_path__ + "./fonts/connect-email-icon.84766e38bdcf6d13ad245939616f8a48.svg";
export { SvgConnectEmailIcon as ReactComponent };